'use strict';
import angular from 'angular';
import ngMaterial from 'angular-material';
import ngMessages from 'angular-messages';
import focusOnEnter from '../../components/focus-on-enter';
import QuickOrderController from './quick-order.controller';
import RxCredentialListService from '../rx-credential-list/rx-credential-list.service';
// import NavbarService from '../navbar/navbar.service';
import QuickOrderService from './quick-order.service';
import CartService from '../../app/cart/cart.service';
import ProductService from '../../app/products/product-detail/product.service';
import tooltip from '../tooltip';
export default angular.module('eeComUiApp.quickOrder', [ngMaterial, ngMessages, tooltip, focusOnEnter])
    .service('RxCredentialListService', RxCredentialListService)
    // .service('NavbarService', NavbarService)
    .service('ProductService', ProductService)
    .service('QuickOrderService', QuickOrderService)
    .service('CartService', CartService)
    .component('quickOrder', {
    template: require('./quick-order.html'),
    controller: QuickOrderController
})
    .name;
//# sourceMappingURL=index.js.map